import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { List } from 'semantic-ui-react';

// Components
import SchemaAttributesListItem from './components/SchemaAttributesListItem';

// Selectors
import { selectIds } from './selectors';

interface Props {
    ids?: number[];
    disableIntructions?: boolean;
}

export class SchemaAttributesList extends React.PureComponent<Props> {
    render() {
        const { ids, disableIntructions } = this.props;
        if (!ids || !ids.length) return null;

        return (
            <List relaxed>
                {ids.map((id, index) => (
                    <SchemaAttributesListItem
                        key={id}
                        schemaAttributeId={id}
                        disableIntructions={disableIntructions}
                    />
                ))}
            </List>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    ids: selectIds
});

export default connect(mapStateToProps)(SchemaAttributesList);
